import { render, staticRenderFns } from "./SectionTools.vue?vue&type=template&id=0d037628&scoped=true&"
import script from "./SectionTools.vue?vue&type=script&lang=js&"
export * from "./SectionTools.vue?vue&type=script&lang=js&"
import style0 from "./SectionTools.vue?vue&type=style&index=0&id=0d037628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d037628",
  null
  
)

export default component.exports